import React, { Component } from 'react';
import { Img } from 'react-image';
import ReactPiwik from 'react-piwik';

class Sponsoren extends Component {

    componentDidMount(){
        document.title = "Sponsoren – vspace.one"
        ReactPiwik.push(['trackPageView'])
    }

    render() {

        let netcupLinkParams = {
            href: "https://www.netcup.de/",
            target: "_blank",
            rel: "noopener noreferrer"
        }

        let netcupLogo = <a {...netcupLinkParams}><Img src="/pic/sponsors/netcup_logo_RGB_color.svg" alt="Netcup Logo"></Img></a>
        let netcupText = <p><a {...netcupLinkParams}>netcup.de</a> – Webhosting, Servermanagement, Colocation und weitere Internetdienstleistungen für einen zuverlässigen und sicheren Internetauftritt.</p>

        let infoLogo = <Img style={{width:"100%"}} src="/pic/sponsors/undraw_businessman_re_mlee.svg"></Img>
        let infoText = <p>Interesse an einer Kooperation?<br></br>Schreib uns an <a href="mailto:vorstand@vspace.one">vorstand [at] vspace.one</a></p>

        return (
            <div className="container-fluid bg-2 text-center" id="getamember">
                <div style={{marginBottom: '3rem'}} className="row">
                    <div className="col-sm-offset-2 col-sm-8">
                        <h1>Unsere Sponsoren</h1>
                    </div>
                </div>
                <Sponsor num={0} logo={netcupLogo} text={netcupText} />
                <div style={{marginBottom: '3rem'}}></div>
                <Sponsor num={1} logo={infoLogo} text={infoText} />
            </div>
        );
    }
}

export default Sponsoren;

class Sponsor extends Component {

    render() {

        let key = this.props.num
        let logoFirst = (key%2 === 0)
        let logo = this.props.logo
        let text = this.props.text

        let itemStyle = {textAlign:'center'}

        return (
            <div className="partner-card" style={{marginBottom: '2rem'}}>
                <div style={{display:'flex', alignItems:'center'}} className="row hidden-xs hidden-sm">
                    <div {...itemStyle} className="col-xs-offset-0 col-xs-8">
                        {logoFirst ? logo : text}
                    </div>
                    <div {...itemStyle} className="col-xs-offset-0 col-xs-4">
                        {logoFirst ? text : logo}
                    </div>
                </div>
                <div className="row visible-xs visible-sm">
                    <div {...itemStyle} className="col-xs-offset-0 col-xs-12">
                        {logo}
                    </div>
                    <div {...itemStyle} className="col-xs-offset-0 col-xs-12">
                        {text}
                    </div>
                </div>
            </div>
        );
    }
}
